import { useQuery } from '@tanstack/react-query';
import {
  getNonPartnerInsuranceByStudentId, getNonPartnerInsuranceCompanies,
  getNonPartnerInsuranceCompanyById
} from '@uplift/api';

import { BaseQueryOpts } from '../baseTypes';
import { higherEdQueryKeys } from './higherEdQueryKeys';

export const useNonPartnerInsuranceCompaniesQuery = (stateId?: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: higherEdQueryKeys.nonPartnerInsuranceCompanies(stateId),
    queryFn: async () => {
      const nonPartnerInsuranceCompanies = await getNonPartnerInsuranceCompanies(stateId);

      return nonPartnerInsuranceCompanies.data;
    },
    ...opts,
  });
};

export const useNonPartnerInsuranceCompanyQuery = (companyId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: higherEdQueryKeys.nonPartnerInsuranceCompany(companyId),
    queryFn: async () => {
      const nonPartnerInsuranceCompany = await getNonPartnerInsuranceCompanyById(companyId);

      return nonPartnerInsuranceCompany.data;
    },
    ...opts,
  });
};

export const useNonPartnerInsuranceByStudentIdQuery = (studentId: string, includeArchived = false, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: higherEdQueryKeys.nonPartnerInsuranceByStudentId(studentId, includeArchived),
    queryFn: async () => {
      const nonPartnerInsurance = await getNonPartnerInsuranceByStudentId(studentId, includeArchived);

      return nonPartnerInsurance.data;
    },
    ...opts,
  });
};
